module.exports = __webpack_public_path__ + "static/orange-d66e76a2bf6d7461483f06c18ec0f360.svg";